import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { GlobalVariable } from '../app.globalvariable'; 

@Component({
  selector: 'app-default',
  templateUrl: './homelayout.component.html',
  styleUrls: ['./homelayout.component.scss']
})
export class HomeLayoutComponent implements OnInit {

  sideBarOpen = true;
  pageLoading = false;

  constructor(private router : Router) {
    
  
  }

  ngOnInit(): void {
  }

  getInfo(showLoad) {
    this.pageLoading = showLoad.pageLoading;
  }

  sideBarToggler(e:any){
    this.sideBarOpen = ! this.sideBarOpen;
  }

  logout(e:any) {
    GlobalVariable.clearAuthToken();
    this.router.navigateByUrl("/");
  }
}

